//LOTTERY VARIABLES
let edLastTotalCount = 0;
let edCartAction = '';
let edLotteryTotalCount;
let edLotteryLastTotalPrice;
let lotteryCartElement = document.querySelector('.ed-lottery-cart');
let edLotteryProduct = lotteryCartElement.getAttribute('data-free-product');
let edHeaderCounter = document.querySelector('.Header__CartCount');
let edCartHeaderCounter = document.querySelector('.ed_cart__items');



function addLotteryProduct(totalCount) {

  if(edLotteryProduct) {
    CartJS.removeItemById(edLotteryProduct);

    let updateCartData = {};
    updateCartData[edLotteryProduct] = totalCount;

    CartJS.updateItemQuantitiesById(updateCartData);
  }
}

$(document).on('cart.ready', function (event, cart) {

  let edTotalPrice = cart.items_subtotal_price / 100;
  let totalCount = Math.floor(edTotalPrice / 10);
  edLotteryLastTotalPrice = edTotalPrice;
  edLotteryTotalCount = totalCount;

  edHeaderCounter.innerText = cart.item_count - edLotteryTotalCount;
  edCartHeaderCounter.innerText = cart.item_count - edLotteryTotalCount;


  if (lotteryCart) {
    edLastTotalCount = totalCount;
    addLotteryProduct(edLotteryTotalCount);
    updateLotteryProgressBar(totalCount);
  }
});

$(document).on('cart.requestComplete', function (event, cart) {
  let edTotalPrice = cart.items_subtotal_price / 100;
  let totalCount = Math.floor(edTotalPrice / 10);

  edHeaderCounter.innerText = cart.item_count - totalCount;
  edCartHeaderCounter.innerText = cart.item_count - totalCount;

  if (lotteryCart) {
    if (totalCount > edLastTotalCount) {
      edCartAction = 'add';

    } else if (totalCount < lastTotalCount) {
      edCartAction = 'remove';
    }
    edLastTotalCount = totalCount;
    updateLotteryProgressBar(totalCount);

    if (edTotalPrice !== edLotteryLastTotalPrice) {
      var lastLoggedTens = Math.floor(edLotteryLastTotalPrice / 10) * 10;
      var currentTens = Math.floor(edTotalPrice / 10) * 10;

      edLotteryLastTotalPrice = edTotalPrice;

      if (currentTens > lastLoggedTens) {
        lastLoggedTens = currentTens;
      }
      addLotteryProduct(totalCount)
    }
  }
});

function updateLotteryProgressBar(count) {
  const progressBar = document.querySelector('.ed-lottery-cart .progress-bar .progress');
  const edLotteryMilestones = document.querySelectorAll('.ed-lottery-cart .milestone');

  edLotteryMilestones.forEach(milestone => milestone.classList.remove('ed-animation-circle'));

  const milestoneValues = Array.from(edLotteryMilestones).map(milestone => {
    if (milestone.dataset.milestoneOne) return parseInt(milestone.dataset.milestoneOne, 10);
    if (milestone.dataset.milestoneTwo) return parseInt(milestone.dataset.milestoneTwo, 10);
    if (milestone.dataset.milestoneThree) return parseInt(milestone.dataset.milestoneThree, 10);
    if (milestone.dataset.milestoneFour) return parseInt(milestone.dataset.milestoneFour, 10);
    if (milestone.dataset.milestoneFive) return parseInt(milestone.dataset.milestoneFive, 10);
  });

  const filteredMilestoneValues = milestoneValues.filter(value => !isNaN(value));
  let isAnyMilestoneReached = false;
  let missingAmount = 1;
  let lastMilestoneReachedIndex = null;

  // Update active class for milestones based on current count
  edLotteryMilestones.forEach((milestone, index) => {
    const milestoneValue = filteredMilestoneValues[index];
    const hintAttribute = `milestone-${index + 1}Hint`;

    if (count >= milestoneValue) {
      milestone.classList.add('active-milestone');
      isAnyMilestoneReached = true;
      lastMilestoneReachedIndex = index; // Track the last reached milestone index

      if (milestone.dataset[hintAttribute]) {
        activeHint = milestone.dataset[hintAttribute];
      }
    } else {
      milestone.classList.remove('active-milestone');
    }
  });

  // If there is a last reached milestone, add the animation class to it
  if (lastMilestoneReachedIndex !== null) {
    edLotteryMilestones[lastMilestoneReachedIndex].classList.add('ed-animation-circle');
  }

  applyLotteryAnimationCircle(edLotteryMilestones, count, filteredMilestoneValues);

  // Determine the missing amount for the next milestone
  for (let i = 0; i < filteredMilestoneValues.length; i++) {
    if (count < filteredMilestoneValues[i]) {
      missingAmount = filteredMilestoneValues[i] - count;
      break;
    }
  }

  /*if (!isAnyMilestoneReached) {
    if (count === 0) {
    } else {
      if (missingAmount === 1) {
        subtitle.textContent = `Füge ein Tattoo für kostenlosen Versand hinzu`
      } else {
        subtitle.textContent = `Füge ${missingAmount} Tattoos für kostenlosen Versand hinzu`
      }
    }
  } else if (activeHint) {
    let replacementText = missingAmount > 1 ? `${missingAmount} Tattoos` : `ein Tattoo`;
    subtitle.textContent = activeHint.replace('((missing_amount))', replacementText);
  }*/

  let lotteryProgressWidth = 0;
  if (count >= filteredMilestoneValues[filteredMilestoneValues.length - 1]) {
    lotteryProgressWidth = 100;
  } else {
    for (let i = 0; i < filteredMilestoneValues.length - 1; i++) {
      if (count === filteredMilestoneValues[i]) {
        // If the count matches a milestone, fill up to that milestone.
        lotteryProgressWidth = (i / (filteredMilestoneValues.length - 1)) * 100;
        break;
      } else if (count > filteredMilestoneValues[i] && count < filteredMilestoneValues[i + 1]) {
        // If the count is in between milestones, fill up to the last milestone.
        lotteryProgressWidth = (i / (filteredMilestoneValues.length - 1)) * 100;
        break;
      }
    }
  }

  progressBar.style.width = `${lotteryProgressWidth}%`;
}

function applyLotteryAnimationCircle(edLotteryMilestones, count, filteredMilestoneValues) {
  let inBetweenMilestones = false;
  for (let i = 0; i < filteredMilestoneValues.length - 1; i++) {
    if (count > filteredMilestoneValues[i] && count < filteredMilestoneValues[i + 1]) {
      inBetweenMilestones = true;
    }


  }

  if (count > filteredMilestoneValues[filteredMilestoneValues.length - 1] || edCartAction === 'remove' || inBetweenMilestones) {
    return;
  }

  edLotteryMilestones.forEach(milestone => {
    if (milestone.classList.contains('ed-animation-circle')) {
      const animationContainer = milestone.querySelector('.animation-circle-container-discount-bar');
      if (animationContainer) {
        const animationCircle = document.createElement('div');
        animationCircle.className = 'animation-circle-discount-bar';
        animationContainer.appendChild(animationCircle);

        setTimeout(() => {
          animationCircle.remove();
        }, 350); // Match the animation duration
      }
    }
  });
}
